import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useGlobalContext } from '../../context/GlobalContext';
import { useTranslation } from 'react-i18next';

const EmailLanguageSelector = ({
  displayFlag = true,
  onLanguageChange = () => {}
}) => {
  const { t } = useTranslation();
  const {
    languages: globalLanguages,
    currentLanguage: globalCurrentLanguage,
    defaultLanguage: globalDefaultLanguage
  } = useGlobalContext();

  const isFirstRender = useRef(true);

  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    return globalCurrentLanguage ||
           globalLanguages.find(lang => lang.code === globalDefaultLanguage) ||
           globalLanguages[0];
  });
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (globalCurrentLanguage && globalCurrentLanguage.code !== selectedLanguage?.code) {
      setSelectedLanguage(globalCurrentLanguage);
    }
  }, [globalCurrentLanguage]);

  useEffect(() => {
    if (!isFirstRender.current && onLanguageChange && selectedLanguage) {
      onLanguageChange(selectedLanguage);
    }
    isFirstRender.current = false;
  }, [selectedLanguage, onLanguageChange]);

  if (!globalLanguages || globalLanguages.length < 1) return null;

  const handleLanguageSelect = (lang) => {
    setTouched(true);
    setSelectedLanguage(lang);
    onLanguageChange(lang);
  };

  return (
    <div className="langueMail">
      <p id="langue_du_mail" className="langueMailLabel medium-label">
        {t("Choisissez la langue de l'email qui sera envoyé au destinataire.")}
      </p>
      <div className="langCards" role="radiogroup" aria-labelledby="langue_du_mail">
        {globalLanguages.map(lang => {
          const isSelected = touched && selectedLanguage?.code === lang.code;
          return (
            <button
              key={lang.code}
              type="button"
              role="radio"
              aria-checked={isSelected}
              className={`langCard${isSelected ? ' selected' : ''}`}
              onClick={() => handleLanguageSelect(lang)}
            >
              {displayFlag && (
                <img
                  src={`assets/images/flags/${lang.code}.png`}
                  className="icon-small"
                  alt=""
                />
              )}
              <span className="capitalize">{lang.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

EmailLanguageSelector.propTypes = {
  displayFlag: PropTypes.bool,
  onLanguageChange: PropTypes.func
};

export default EmailLanguageSelector;
